import { CSSProperties } from 'react'

export const s = {
  root: {
    display: 'flex',
    flexDirection: 'column',
  } as CSSProperties,
  title: {
    marginTop: 10,
    marginBottom: 14,
  } as CSSProperties,
  statusTag: {
    border: '1px solid #AF231C',
    padding: 4,
    color: '#AF231C',
    backgroundColor: '#F7E9E8',
    borderRadius: 2,
    textAlign: 'center'
  } as CSSProperties,
  notification: {
    body: {
      width: 380,
    } as CSSProperties,
    text: { fontSize: 24 } as CSSProperties,
  },
  dateTime: {
    color: '#595959',
    fontSize: 24,
    marginBottom: 42,
  } as CSSProperties,
  location: {
    fontSize: 14,
  } as CSSProperties,
  stepsIcon: {
    width: 32,
  } as CSSProperties,
  button: {
    marginLeft: 'auto',
    backgroundColor: 'transparent',
  } as CSSProperties,
  noEventsTitle: {
    margin: '20px 0px'
  } as CSSProperties
}
